'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "DescriptionList": "Polaris-DescriptionList",
  "Term": "Polaris-DescriptionList__Term",
  "spacingTight": "Polaris-DescriptionList--spacingTight",
  "Description": "Polaris-DescriptionList__Description"
};

exports.default = styles;
